import React, { useMemo } from "react";
import {
    getLocalTodayDateOnly,
    WORK_DATE_VISIBLE_PRESETS,
} from "@helpers/date";
import { AggregatedDateFilter } from "@components/pageHeader/filters/AggregatedFilters/DateFilter/AggregatedDateFilter";
import {
    buildWorkDeliveryDatePresetPatch,
    buildWorkDeliveryDatePresets,
} from "./workDeliveryDatePresets";
import { BaseFilterProps, filterValueMapping, FilterTabs } from "../../lib";

interface Props extends BaseFilterProps {
    maxDate: Date;
}

/** Work end date filter, with the relative Work end presets. */
export const WorkDeliveryDateFilter: React.FC<Props> = ({
    filters,
    onChange,
    maxDate,
}) => {
    const today = getLocalTodayDateOnly();
    const presets = useMemo(() => buildWorkDeliveryDatePresets(today), [today]);
    const mapping = filterValueMapping[FilterTabs.WORK_DELIVERY_DATE];

    return (
        <AggregatedDateFilter
            filters={mapping.to(filters)}
            onChange={(newValue) => {
                onChange({
                    ...mapping.from(newValue),
                    workDeliveryDatePreset: undefined,
                });
            }}
            maxDate={maxDate}
            visiblePresets={WORK_DATE_VISIBLE_PRESETS}
            relativePresets={{
                presets,
                selectedId: filters.workDeliveryDatePreset,
                onSelect: (preset) => {
                    onChange(buildWorkDeliveryDatePresetPatch(preset));
                },
            }}
        />
    );
};
